<style scpoed>
 /deep/ .v-text-field {
   width: 400px;
 }
 .v-text-field > .v-input__control > .v-input__slot input {
   padding-left: 5px;
 }
 .patch-num-design,
 .patch-num-design input {
   width: 50px;
   text-align: center;
   font-family: D7MB;
   color:#242424;
 }
 .title-in-card {
   margin-bottom: 10px;
 }
 .patch-no-area {
   padding-left: 10px
 }
 .patch-name-area {
   width: 100%;
   padding-bottom: 8px;
 }
 .patchinfo-title-area {
   padding: 0 10px;
 }
 .patchinfo-title-area > .patchinfo-title-area-head {
   font-weight: bold;
 }
 .patchinfo-title-area > .patchinfo-title-area-child {
   width: 50%;
 }
 .patchinfo-title-area > .patchinfo-title-area-child.patchinfo-title-area-head {
   display: flex;
   justify-content: flex-start;
 }
 .patchinfo-title-area > .patchinfo-title-area-child.patchinfo-title-area-tail {
   display: flex;
   justify-content: flex-end;
 }
 .justify-align-center {
  display: flex;
  justify-content:center;
  align-items: center;
 }
 .patch-no-name-area-parent-00 {
   flex-direction: row;
   width: 100%
 }
 .patch-no-name-area-child-00 {
   width: 640px
 }
 .patch-no-name-area-child-01 {
   width: 188px
 }
 div.v-counter {
   padding-right: 16px;
 }
 /* --- */
</style>
<template>
  <div>
    <v-card class="patch_name_property">
      <v-card-text>
        <div class="text-overline mb-1 patchinfo-title-area justify-align-center direction-row">
          <div class="patchinfo-title-area-child patchinfo-title-area-head"><v-icon>mdi-form-textbox</v-icon> &nbsp; Patch name</div>
          <div class="patchinfo-title-area-child patchinfo-title-area-tail">
            <!--
            <v-btn
                text
                color="blue darken-1"
                v-on:click="openDeviceCommunication"
                class="ma-2"
            >
              <v-icon>{{ icons.mdiMidiPort }}</v-icon> &nbsp; Port & Patch
            </v-btn>
            -->
          </div>
        </div>
        <div class="patch-no-name-area-parent-00 justify-align-center">
          <div class="patch-no-name-area-child-00 justify-align-center">
            <v-list-item three-line>
              <v-list-item-content>
                <v-form v-model="isValidationOK">
                  <v-text-field
                      ref="patch_name"
                      label="Patch name"
                      type="string"
                      v-model="patchname_param_name"
                      hide-details="auto"
                      class="mx-2 text-h5"
                      :maxlength="patchNameLength"
                      :counter="patchNameLength"
                      :rules="patchNameRules"
                      :disabled="enableControl"
                  />
                </v-form>
                <v-list-item-subtitle>
                  <span class="patch-no-area">Patch#: <span class="mx-2 patch-num-design">{{ patchname_param.num }}</span></span>
                </v-list-item-subtitle>
              </v-list-item-content>

            </v-list-item>
          </div>
          <!--
          <div class="patch-no-name-area-child-01 justify-align-center">
            <v-menu
                offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    color="red lighten-1"
                    elevation="2"
                    :disabled="patchname_param.isSynced"
                    v-bind="attrs"
                    v-on="on"
                    class="mx-2 white--text"
                >
                  <v-icon>
                    {{ icons.mdiCog }}
                  </v-icon>
                  &nbsp; action
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                    v-for="(item, index) in sync_menus"
                    :key="index"
                >
                  <v-list-item-title>
                    <v-btn
                        rounded
                        text
                        :color="item.color"
                        v-on:click="onIsSyncedMenuClicked(`${item.action}`)"
                    ><v-icon>{{`${item.iconText}`}}</v-icon>&nbsp;{{ item.title }}</v-btn>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          -->
        </div>
      </v-card-text>
      <!--
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            text
            color="blue darken-1"
            v-on:click="openDeviceCommunication"
            class="ma-2"
        >
          <v-icon>{{ icons.mdiMidiPort }}</v-icon> &nbsp; Load Patch
        </v-btn>
      </v-card-actions>
      -->
    </v-card>

  </div>
</template>

<script>
 import { sysex_cfg } from '../vanilla/scripts/ewi4000sconst.js';

 export default {
   name: 'PatchNumNameCard',
   props: ['patchnameparam', 'label'],
   data: () => ({
     sync_menus: [
       {
         title: 'Sync to Device',
         iconText: 'mdi-camera-flip',
         color: 'primary',
         action: 'syncToDevice',
         disabled: false
       },
       {
         title: 'Discard Change',
         iconText: 'mdi-file-undo',
         color: 'red accent-2',
         action: 'discardChange',
         disabled: false
       },
     ],
     patchname_param: {
       name: '',
       num: '',
       isSynced: true
     },
     patchNameRules: [
       v => !!v || 'Patch name is required',
       v => v.length <= sysex_cfg.EWI_PATCHNAME_LENGTH || `Name must be less than ${sysex_cfg.EWI_PATCHNAME_LENGTH} characters.`,
       v => v.match(/^[\x20-\x7e]*$/)!=null || `ASCII characters Only.`
     ],
     patchNameLength: sysex_cfg.EWI_PATCHNAME_LENGTH
   }),
   computed: {
     /*
     patchname_param_isSynced: {
       get: function() {
         if (this.$store.getters.getWorkingPatchIdx()==null) {
           return true
         }
         const workingPatch_idx = this.$store.getters.getWorkingPatchIdx()
         return this.$store.getters.getCheckOneEditPatchIsSynced(workingPatch_idx)
       },
       set: function(state) {
         this.$set(this.$data.patchname_param, 'isSynced', state)
       }
     },
      */
     isValidationOK: {
       get: function() {
         return this.$store.getters.getIsValidationOK()
       },
       set: function(newValue) {
         this.$store.commit('onUpdateIsValidationOK', {value: newValue})
       }
     },
     enableControl: {
       get: function() {
         // cloase all panels
         // [TODO] made this line to comment due to avoid closing panels even in the case of discarding parameter changes.
         // vvvv vvvv vvvv
         //this.$store.commit('onUpdateStatusExpandPanel', {value: []})
         if (typeof this.$refs.PatchNumNameCard != 'undefined') {
           this.$refs.PatchNumNameCard.clearPatchNamePatchNo()
         }
         return !this.$store.getters.getEnableControl()
       }
     },
     patchname_param_name: {
       get: function() {
         return this.$data.patchname_param.name.replace(/ +$/, '')
       },
       set: function(newValue) {
         if (newValue.length > sysex_cfg.EWI_PATCHNAME_LENGTH) {
           newValue = newValue.substr(0, sysex_cfg.EWI_PATCHNAME_LENGTH)
         }
         console.log(newValue, newValue.length)
         this.$set(this.$data.patchname_param, 'name', `${newValue}`)
         this.onUpdatePatchName('patchName', newValue)
       }
     }
   },
   created: function() {
     this.patchname_param.name = this.patchnameparam.name
     this.patchname_param.num = this.patchnameparam.num
     this.patchname_param.isSynced = this.patchnameparam.isSynced
     console.log(`<CREATE> label=[${this.label}]`, this.patchname_param)
   },
   watch: {
   },
   methods: {
     dump_patchname_param: function() {
       const workingPatch_idx = this.$store.getters.getWorkingPatchIdx()
       const workingPatch = this.$store.getters.getOneEditPatch(workingPatch_idx)
       console.log(`[store:${this.label}]`, workingPatch.decoded)
       console.log(`[local:${this.label}]`, this.$data.patchname_param.name)
     },
     clearPatchNamePatchNo: function() {
       this.$set(this.$data.patchname_param, 'name', '')
       this.$set(this.$data.patchname_param, 'num', '')
     },
     /*
     openDeviceCommunication: function() {
       this.$router.app.$children[0].openDeviceCommunicationApp(true)
       //this.$refs.router.$refs.MidiDeviceControls.handleDeviceCommunicationDialog(true)
     },
     updateParamIsSynced: function() {
       const workingPatch_idx = this.$store.getters.getWorkingPatchIdx()
       const isSynced = this.$store.getters.getCheckOneEditPatchIsSynced(workingPatch_idx)
       console.log(`[PatchNumNameCard.vue: updateParamIsSynced] isSynced=[${isSynced}]`)
       this.$set(this.$data.patchname_param, 'isSynced', isSynced)
     },
     */
     onUpdatePatchName: function(key, val) {
       //console.log(this.formant_param, key, val, this.$data)
       //const workingPatch_idx = this.$store.getters.getWorkingPatchIdx()
       //const workingPatch = this.$store.getters.getOneEditPatch(workingPatch_idx)
       //console.log(this.label, workingPatch)
       if (val.length < sysex_cfg.EWI_PATCHNAME_LENGTH) {
         const rest_num = Number(sysex_cfg.EWI_PATCHNAME_LENGTH) - val.length
         const rest_letter = ((new Array(rest_num)).fill(' ')).join('')
         val = `${val}${rest_letter}`
       } else {
         val = val.substr(0, sysex_cfg.EWI_PATCHNAME_LENGTH)
       }

       this.$set(this.$data.patchname_param, key, val)
       this.$store.commit('onEditOneEditPatch', {arr_idx: [`${key}Decoded`], value: val})

       const workingPatch_idx = this.$store.getters.getWorkingPatchIdx()
       const workingPatch = this.$store.getters.getOneEditPatch(workingPatch_idx)
       console.log(workingPatch.decoded.isSynced)
       this.$data.patchname_param.isSynced = workingPatch.decoded.isSynced
       this.$router.app.$children[0].updateParamIsSyncedApp()
     },
     //
     //
     /*
     onIsSyncedMenuClicked(action=null) {
       if (action==null) return
       switch(action) {
         case 'syncToDevice':
           console.log(this.$router)
           this._onSyncParamEditOnePatchToDevice()
           break
         case'discardChange':
           this._onDiscardChange()
           break
       }
     },
     _onSyncParamEditOnePatchToDevice() {
     this.$router.app.$children[0].syncParamEditOnePatchToDeviceApp()
     },
     _onDiscardChange() {
       this.$router.app.$children[0].discardParamEditOnePatchApp()
     }
     */
   },
 }
</script>
